import api from "@services/apiList";
import {
  AllDocumentsByPatientPayload,
  LabDetailsType,
  RadiologyDetailsType,
  UploadedDocumentsParams,
  UploadedDocumentsResponseType,
  ViewDetailsParams,
  ViewVDetailsResponseType,
} from "./types";
import instance from "@services/services";
import { getConstants } from "@utilifiles/methods/storage/storage";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
const { clinicId } = getConstants();
const { emr } = api;

export const getAllDocumentsByPatientMasterId = async ({
  patientMasterId,
  clinicId,
}: {
  patientMasterId: number;
  clinicId: number;
}): Promise<ResponseType<AllDocumentsByPatientPayload>> => {
  const result = await instance.get(
    `${api.patientRegistrationApi.allDocumentsByPatientMasterId}${patientMasterId}?clinicId=${clinicId}`,
  );
  return result.data;
};

export const getViewDetails = async (
  data: ViewDetailsParams
): Promise<ResponseType<ViewVDetailsResponseType[]>> => {
  const result = await instance.post(emr.viewdetails, data);
  return result.data;
};

export const getLabDetails = async (
  id: number
): Promise<ResponseType<Array<{testName:string,labId:number,data:LabDetailsType[]}>>> => {
  const result = await instance.get(
    `${emr.getViewLabDetails}${clinicId}?enId=${id}`
  );
  return result.data;
};

export const getRadiologyDetails = async (
  id: number
): Promise<ResponseType<RadiologyDetailsType[]>> => {
  const result = await instance.get(
    `${emr.getViewRadiologyDetails}${clinicId}?enId=${id}`
  );
  return result.data;
};

export const getAllUploadedDocuments = async (
  params: UploadedDocumentsParams
): Promise<
  ResponseType<{ totalcount: number; items: UploadedDocumentsResponseType[] }>
> => {
  const result = await instance.post(emr.getAllUploadedDocuments, params);
  return result.data;
};

export const viewUploadedDocments = async (body: {
  uploadFile: string;
  clinicId: number;
}): Promise<ResponseType<{ file: string; content: string | null }>> => {
  console.log(body)
  const result = await instance.post(emr.getViewUploadedFile, body);
  return result.data;
};

// consentforms/dischargehistorysummary/10?clinicId=1

export const dischargeHistorySummary = async (
  id: string
): Promise<ResponseType<{ file: string; content: string | null }>> => {
  const url = `${emr.getDischargeHistorySummary}/${id}`; // Replace placeholder
  return (await instance.get(`${url}?clinicId=${clinicId}`)).data;
};

export const dischargeHistorySummaryv2 = async ({id,insname}: {id:string,insname?:string}): Promise<ResponseType<{ file: string; content: string | null }>> => {
  const url = `${emr.getDischargeHistorySummaryv2}/${id}`; // Replace placeholder
  return (await instance.get(`${url}?clinicId=${clinicId}&insname=${insname}`)).data;
};
